<template>
  <v-alert
    :value="missingInformation.length > 0 && !checkCompanyProfilePending"
    type="warning"
    class="my-0"
    style="border-top: none;"
  >
    {{ $t('texts.completeCompanyProfile') }}
    <v-btn
      v-for="(information, index) in missingInformation" :key="index"
      :to="`/company/${selectedCompanyId}/profile/${information}`"
      outlined
      color="white"
      small
      class="ml-2"
    >
      <template v-if="information === 'images'">
        {{ $t('texts.company.profile.images') }}
      </template>
      <template v-else-if="information === 'contact-person'">
        {{ $t('texts.contactPerson') }}
      </template>
      <template v-else>
        {{ information }}
      </template>
    </v-btn>
  </v-alert>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'MissingInformation',
  computed: {
    ...mapCompanyProfileState([
      'checkCompanyProfilePending',
      'missingInformation',
    ]),
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
};
</script>
